import BaseFeature from '../../foundation/base/base';

class GtmEcommDetail extends BaseFeature {
	constructor(element) {
		super(element);
		this.element = element;
		this.initDomCache();
		this.data = element.dataset.impression ? JSON.parse(element.dataset.impression) : null;
		this.button = this.dom.action;
		this.form = element.closest('form');
		this.submitted = false;
		this.variant = this.dom.variant;
		this.quantity = this.dom.quantity;
		this.dynamicPrice = false;
		this.unitPriceExclVat = 0;
		this.ecommData = {
			event: 'view_item',
			ecommerce: {
				currency: '',
				value: 0.0,
				items: [
					{
						item_id: '',
						item_name: '',
						price: 0.0,
						item_brand: '',
						item_category: '',
						item_variant: '',
						quantity: '',
					},
				],
			},
		};

		this.ecommerceHead = this.ecommData.ecommerce;
		this.init();
	}

	init() {
		this.ecommerceHead.currency = 'DKK';
		this.ecommerceHead.value = 0.0;
		const [productObj] = this.ecommData.ecommerce.items;
		this.ecommDataProduct = productObj;
		this.ecommDataProduct.item_name = this.data.item_name;
		this.ecommDataProduct.item_id = this.data.item_id;
		this.ecommDataProduct.price = 0.0;
		this.ecommDataProduct.item_brand = this.data.item_brand;
		this.ecommDataProduct.item_category = this.data.item_category;
		this.ecommDataProduct.item_variant = this.data.item_variant;

		if (this.variant) {
			this.ecommDataProduct.variant = this.variant.value;
			this.variant.addEventListener('change', (e) => {
				this.ecommDataProduct.item_variant = e.target.value;
				this.log('change', e.target.value);
			});
		}

		if (this.quantity) {
			this.ecommDataProduct.quantity = this.quantity.value;
			this.quantity.addEventListener('change', (e) => {
				if (!this.dynamicPrice) {
					this.ecommDataProduct.quantity = e.target.value;
				}

				this.log('change', e.target.value);
			});
		} else {
			this.ecommDataProduct.quantity = 1;
		}

		this.log(this.ecommData);

		this.log('GA4 view_item');
		this.push();

		this.subscribe('dynamicPrice.change', () => {
			this.ecommDataProduct.quantity = 1;
			this.log('dynamicPrice change', this.ecommDataProduct.quantity);
		});

		this.subscribe('dynamicPrice.init', (data) => {
			/**
				If the price is dynamically calculated set true
			*/
			this.dynamicPrice = data;
		});
	}

	push() {
		if (window.dataLayer) {
			// unit price
			let unitPriceExclVat = 0;

			const footerProductText = 'div.m-product-pos-bar__content h3';
			const cardProductText = 'div.m-variant-card__description h2';
			const heroProductText = 'div.m-product-hero__content h1';
			const productElement = document.querySelectorAll(
				heroProductText,
				cardProductText,
				footerProductText);

			const footerProductPrice = 'm-product-pos-bar__price a-heading a-heading--level-3';
			const cardProductPrice = 'm-variant-card__value';
			const heroProductPrice = 'm-product-hero__price a-heading';
			let headingPriceElements = document.getElementsByClassName(footerProductPrice);
			if (headingPriceElements === null) {
				headingPriceElements = document.getElementsByClassName(cardProductPrice);
				if (headingPriceElements === null) {
					headingPriceElements = document.getElementsByClassName(heroProductPrice);
				}
			}

			const dynamicPriceElement = document.querySelector('[data-js=\'product-dynamic-price__priceExclVat\']');
			if (dynamicPriceElement) {
				unitPriceExclVat = dynamicPriceElement.innerHTML.replace('.', '').replace('-', '').replace(',', '.');
				this.ecommDataProduct.item_name = productElement;
			} else if (headingPriceElements.length > 0) {
				unitPriceExclVat = headingPriceElements[0].innerHTML.replace('.', '').replace('-', '').replace(',', '.');
			}

			this.unitPriceExclVat = unitPriceExclVat;

			// if (this.unitPriceExclVat.at(-1) === '.') {
			// 	this.unitPriceExclVat = this.unitPriceExclVat.slice(0, -1);
			// }
			this.unitPriceExclVat = parseFloat(this.unitPriceExclVat);

			if (this.dynamicPrice === true) {
				this.ecommDataProduct.item_name = productElement;
				this.ecommerceHead.value = this.unitPriceExclVat;
				this.ecommDataProduct.price = this.unitPriceExclVat;
			} else {
				this.ecommDataProduct.price = this.unitPriceExclVat;
				const totalPrice = this.ecommDataProduct.price * this.ecommDataProduct.quantity;
				this.ecommData.ecommerce.value = totalPrice;
			}

			window.dataLayer.push(this.ecommData);
		}
	}
}

export default GtmEcommDetail;
